import http from 'utilities/httpService';

export class TileTypeService {
  static async getTypeTiles() {
    const url = `/admin/tile-types`;
    return http.get(url);
  }
}
